import React from 'react';
import classnames from 'classnames';
import { IconSize } from '../../../../Icons/IconWrap';
import { limitNumber } from '../../../helpers';
import s from './IconWithNotification.scss';
var IconWithNotification = function (_a) {
    var className = _a.className, Icon = _a.icon, iconClassName = _a.iconClassName, numberClassName = _a.numberClassName, count = _a.count, _b = _a.notificationColor, notificationColor = _b === void 0 ? 'red' : _b, _c = _a.notificationSize, notificationSize = _c === void 0 ? 'small' : _c;
    return (React.createElement("div", { className: classnames(s['root'], className) },
        React.createElement(Icon, { className: classnames(s['icon'], iconClassName), disableDefaultColors: true, size: IconSize.MEDIUM }),
        !!count && (React.createElement("span", { className: classnames(s['number-label'], s[notificationSize], numberClassName) },
            React.createElement("span", { className: classnames(s['number'], s[notificationColor]) }, limitNumber(count))))));
};
IconWithNotification.displayName = 'IconWithNotification';
export default IconWithNotification;
//# sourceMappingURL=IconWithNotification.js.map